import React from "react";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useDialog } from "../../contexts/DialogContext";

export function SimpleModal({ titleText, bodyText, variant = "success" }) {
  const { closeDialog } = useDialog();

  return (
    <>
      <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
        <button
          type="button"
          onClick={closeDialog}
          className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          <span className="sr-only">Close</span>
          <XMarkIcon className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          {variant === "success" ? (
            <CheckCircleIcon
              className="h-6 w-6 text-green-600"
              aria-hidden="true"
            />
          ) : (
            <ExclamationTriangleIcon
              className="h-6 w-6 text-red-600"
              aria-hidden="true"
            />
          )}
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h1
            as="h3"
            className="text-base font-semibold leading-6 text-gray-900"
          >
            {titleText}
          </h1>
          <div className="mt-2">
            <p className="text-sm text-gray-500">{bodyText}</p>
          </div>
        </div>
      </div>
    </>
  );
}
